import { isFunction } from './helpers';

export const MOCK_GET_BOUNDING_CLIENT_RECT = () => ({});
export const MOCK_ELEMENT = { getBoundingClientRect: MOCK_GET_BOUNDING_CLIENT_RECT };

/**
 * getElementSizing
 * Gets the position / dimensions of an element.
 * @param { Object } element: The element to get the position / dimenstions of.
 * @returns { Object } Object containing numberical values of { height, width, top, bottom, left, right }
 */
export const getElementSizing = (element = MOCK_ELEMENT) => {
  if (element && isFunction(element.getBoundingClientRect)) {
    return element.getBoundingClientRect();
  }
  return {};
};

/**
 * getHeight
 * Gets the height of an element.
 * @param { Object } element: The element to get the height of.
 * @returns { Number } The height of element in pixels.
 */
export const getHeight = (element) => getElementSizing(element).height;

/**
 * getTopPosition
 * Gets the top position of an element.
 * @param { Object } element: The element to get the top position of.
 * @returns { Number } The top position of element in pixels.
 */
export const getTopPosition = (element) => getElementSizing(element).top;

/**
 * getBottomPosition
 * Gets the bottom position of an element.
 * @param { Object } element: The element to get the bottom position of.
 * @returns { Number } The bottom position of element in pixels.
 */
export const getBottomPosition = (element) => getElementSizing(element).bottom;
